<template>
    
    <div class="row bg-light py-3 rounded" style="width: 95%;">
        
        <div class="col-md-7">
            <div id="carouselExampleControls" class="carousel slide img-fluid" data-bs-ride="carousel">
                <div class="carousel-inner">
                    <div v-for="(value, key, index) of data" :class="['carousel-item', { 'active': index === 0 }]">
                        <div class="text-center align-items-center" style=" width: 100%;aspect-ratio: 5/3;">
                            <img :src="value['Link']" height="100%" width="100%" class="rounded"/>
                        </div>
                    </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
        </div>
        <div class="col-md-5 text-center justify-content-center d-flex flex-column">
            <h1 class=" text-dark">
                {{ intro['tittle'] }}
                <h3 clsas="d-block">{{ intro['sub'] }}</h3>
            </h1>
            <p class="mb-4 text-dark" style="white-space: pre-line;">{{ intro['introduce'] }}</p>
            <p><router-link to="services" class="btn btn-secondary me-2">Khám phá</router-link></p>
        </div>
    </div>

</template>

<script>
    import { ref, onValue } from "firebase/database";
    import { database } from '../../components/firebase'

    export default{
        data(){
            return{
                data:[],
                intro:[]
            }
        },
        mounted(){
            const CarouselRef = ref(database, 'Carousel/');
            onValue(CarouselRef, (snapshot) => {
                this.data = snapshot.val();
                // console.log(this.data);
            });
            const IntroRef = ref(database, 'Introduce/');
            onValue(IntroRef, (snapshot) => {
                this.intro = snapshot.val();
                // console.log(this.intro);
            });
        }
    }
</script>